function isClient() {
  return typeof process === "undefined" || process.client;
}
export {
  isClient
};
//# sourceMappingURL=client.es.js.map
